import React from 'react'
import { Badge, Tooltip } from '@mantine/core'
import { colorsV2 } from '@/styles/v2/vars/vars.colors'
import { useIsMod, useSubscription } from 'containers/profile/hooks/useProfile'
import { cssClass, userFullName } from '@/shared/utils'
import { IUser } from '@/interfaces/user'
import { User } from 'containers/user/types/user'
import Link from 'next/link'
import { ProfileRecommendation } from 'containers/recommendations/types/recommendations'
import { Icon } from '@/public/assets/v2/images/icons'
import Image from 'next/image'

interface DisplayNameWithBadgeProps {
  profile: IUser | User | ProfileRecommendation
  className?: string[]
  hideBadge?: boolean
}

export const DisplayNameWithBadge = ({
  profile,
  className = [],
  hideBadge,
}: DisplayNameWithBadgeProps) => {
  const name = userFullName(profile)
  const profileIsMod = useIsMod(profile)
  const { subscriptions } = useSubscription(profile)

  switch (true) {
    case profileIsMod:
      return (
        <div
          className={cssClass([
            'flex flex-row items-center font-bold gap-6',
            ...className,
          ])}
        >
          {name}
          {!hideBadge && (
            <Badge size="xs" color={colorsV2.accent.light.tertiary} c="white">
              STAFF
            </Badge>
          )}
        </div>
      )

    case subscriptions.insider_lifetime:
      return (
        <div
          className={cssClass([
            'flex flex-row items-center font-bold gap-6',
            ...className,
          ])}
        >
          {name}
          <Tooltip
            label="This creator is a lifetime Insider!"
            className="flex"
            px={12}
            py={8}
            fz={'12px'}
            lh={'16px'}
            ta={'center'}
            color={colorsV2.background.dark.darkButtonFocused}
            withArrow
            arrowSize={8}
          >
            <Link href="/checkout">
              <Image
                src={Icon.InsidersLifeTimeBadgePNG}
                alt=""
                width={20}
                height={20}
              />
            </Link>
          </Tooltip>
        </div>
      )

    case subscriptions.insider_pro_monthly:
    case subscriptions.insider_pro_yearly:
      return (
        <div
          className={cssClass([
            'flex flex-row items-center font-bold gap-6',
            ...className,
          ])}
        >
          {name}
          <Tooltip
            label="This creator is a Creatorland PRO!"
            className="flex"
            px={12}
            py={8}
            fz={'12px'}
            lh={'16px'}
            ta={'center'}
            color={colorsV2.background.dark.darkButtonFocused}
            withArrow
            arrowSize={8}
          >
            <Link href="/checkout">
              <Image
                src={Icon.InsidersProSubBadgePNG}
                alt=""
                width={20}
                height={20}
              />
            </Link>
          </Tooltip>
        </div>
      )

    case subscriptions.insider_monthly:
    case subscriptions.insider_yearly:
      return (
        <div
          className={cssClass([
            'flex flex-row items-center font-bold gap-6',
            ...className,
          ])}
        >
          {name}
          <Tooltip
            label="This creator is an Insider!"
            className="flex"
            px={12}
            py={8}
            fz={'12px'}
            lh={'16px'}
            ta={'center'}
            color={colorsV2.background.dark.darkButtonFocused}
            withArrow
            arrowSize={8}
          >
            <Link href="/checkout">
              <Image
                src={Icon.InsidersSubBadgePNG}
                alt=""
                width={20}
                height={20}
              />
            </Link>
          </Tooltip>
        </div>
      )

    default:
      return <span className="font-bold">{name}</span>
  }
}
